import { Component, Input } from '@angular/core';
import { DocumentCategory } from 'app/models/dto/document-category.model';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';

@Component({
    selector: 'activity-row-doc-category-verified',
    templateUrl: 'activity-row-doc-category-verified.component.html',
    styles: []
})
export class ActivityRowDocCategoryVerifiedComponent {
    @Input() activity: Activity;
    @Input() documentCategories: DocumentCategory[];
    constructor() {}
    documentCategoryDisplay(category: string) {
      return this.documentCategories.find(c => c.id === category)?.name;
    }
}
